<div *ngIf="rumor" class="quote-card" [ngClass]="{
  'green-gradient': rumor.probability == 'OFFICIAL',
  'black-gradient': rumor.probability == 'NULL',
  'blue-gradient': rumor.type == 'VENTA', 
  'red-gradient': rumor.type == 'FICHAJE', 
  'light-gradient': rumor.type == 'RENOVACIÓN',
  'compact': isCompact
  }">
  <div class="columna">
    <div class="profile-pic">
      <img [src]="rumor.player.imgUrl" [ngClass]="{'multiply-effect': service.isJpg(rumor.player.imgUrl)}" alt="{{rumor.player.name}}">
    </div>
  </div>
  <div class="quote-content title-container">
    <h2 class="player-name">{{rumor.player.commonName ? rumor.player.commonName : rumor.player.name}}</h2>
    <p><strong>Última noticia </strong></p>
    <p>{{ service.getMostRecentDate(rumor.news) | date: 'd MMMM' }} | {{getNewestAuthor(rumor.news) }}</p>
    <p><strong>Posibilidad </strong></p>
    <div class="progress-bar-container">
      <div class="progress-bar" 
        [style.width.%]="service.posibilidadConfig[rumor.probability].value" 
        [style.backgroundColor]="service.posibilidadConfig[rumor.probability].color">
      </div>
    </div>
  </div>
  <div class="team-container">
      <img [src]="rumor.team.imgUrl" alt="{{rumor.team.name}}">
  </div>
  <!-- Name Overlay -->
  <div *ngIf="isCompact" class="player-name-overlay" [ngClass]="{
    'green-player-name': rumor.probability == 'OFFICIAL',
    'black-player-name': rumor.probability == 'NULL',
    'blue-player-name': rumor.type == 'VENTA', 
    'red-player-name': rumor.type == 'FICHAJE', 
    'light-player-name': rumor.type == 'RENOVACIÓN'
    }">
    <div class="name-container">
      <h2 class="player-name" autoscaleTextRumor>
        {{ rumor.player.commonName ? rumor.player.commonName : rumor.player.name }}
      </h2>
    </div>
    <div class="example-spacer"></div>
    <p>{{ service.getRumorType(rumor) }}
      <span *ngIf="rumor.probability === 'OFFICIAL'">OFICIAL</span>
    </p>
  </div>
  <h2 *ngIf="!isCompact" class="signing">{{ service.getRumorType(rumor) }}
    <br *ngIf="rumor.probability === 'OFFICIAL'" />
    <span *ngIf="rumor.probability === 'OFFICIAL'">{{ rumor.type === 'VENTA' ? 'CONFIRMADA' : 'CONFIRMADO' }}</span>
  </h2>
</div>  
      